import React, { useState,useEffect } from 'react';
import './classes/AddAthlete.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { configData } from "../config";
import SalespersonSidebar from './SalespersonSidebar.js';
import Select from 'react-dropdown-select';
import 'react-phone-number-input/style.css';
import AgentBackendSidebar from "./AgentBackendSidebar";
import { Helmet } from 'react-helmet';
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
  isValidPhoneNumber,getCountryCallingCode
} from 'react-phone-number-input'
import { format } from 'date-fns';

const AddAthleteForm = () => {
 const app_url = configData.APP_URL;

 const initialForm = {
  firstName: '',
  lastName: '',
  street: '',
  addressCont: '',
  city: '',
  state: '',
  zip: '',
  country: 'US',
  linkedin_url: '',
  phone: '',
  email: '',
  signing_date: '',
  signing_date_obj:'',
  signing_agent: '',
  current_agent: '',
  assignment_date: '',
  assignment_date_obj:'',
  birthdate: '',
  birthdate_obj:'',
  bio: '',
  pageURL: window.location.href
};
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [countriesList, setCountriesList] = useState([]);
  const [statelist, setStateList] = useState({});
  const [agentlist, setAgentList] = useState({});
  const [selectedState, setSelectedState] = useState('');
  const[message,setMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const loggedin_uid = localStorage.getItem('uid');
  const navigate = useNavigate();
  const [selectedcountry, setSelectedCountry] = useState([{ label: 'United States', value: 'US' }]);
const domainName = window.location.host.replace(/^https?:\/\//, '');
   /* useEffect(() => {
    fetch('') // Replace with  actual URL
      .then((res) => res.json())
      .then((data) => setAgents(data))
      .catch((err) => console.error('Failed to fetch agents:', err));
    }, []); */
    useEffect(() => {
                 Promise.all([
                  retrieveCountriesList(),
                  retrieveStateList(),
                  retrieveAgentList(),
                  checkpermissionforpageaccess()
                 ])
                 .then(() => {
              
                 setIsLoading(false);
                 })
              
             },[]);
const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};

  async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
  async function retrieveAgentList() {
    const response = await fetch(
      app_url+'smwwagency/getagentlist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json();
    if(data.data.msg == "Success") {
   
    setAgentList(data.data.result);
    }
   
  }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);
   
    
    
  }

  async function checkpermissionforpageaccess() {
       
          
               const response = await fetch(
                    app_url+'smwwagency/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
   
          
       }
  
const handleOpen = () => {
    setSelectedCountry([]);
    setFormData(prevState => ({
      ...prevState,
      country:''
    }));

  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    if(event.target.name === 'country') {
      if(event.target.value === 'US' || event.target.value === 'CA') {
        setFormData(prevState => ({
          ...prevState,
          showProvinceField: false,
          showStateField: true,
          province:'',
        }));

      } else {
        setFormData(prevState => ({
          ...prevState,
          showProvinceField: true,
          showStateField: false,
          state: '',
        }));
       
      }
    
    }
  };
// useEffect(() => {
//   console.log("PHONE STATE:", formData.phone);
// }, [formData.phone]);
 
  const validate = (data) => {
  const newErrors = {};

  if (!data.firstName.trim()) {
   // alert('First Name is required');
    newErrors.firstName = 'First Name is required';
    //return false;
  }
  if (!data.lastName.trim())  { 
   // alert('Last Name is required');
    newErrors.lastName = 'Last Name is required';
   // return false;
  }

  if (!data.email.trim()) {
     //alert('Email is required');
    newErrors.email = 'Email is required';
   // return false;
  } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data.email)) {
   // alert('Invalid Email');
    newErrors.email = 'Invalid Email';
   // return false;
  }

 if (data.phone.trim()) {
    const digitsOnly = data.phone.replace(/\D/g, '');

    try {
      // Find the current country code length
      let codeLength = 0;
      if (data.phoneCountry) {
        codeLength = getCountryCallingCode(data.phoneCountry).length;
      } else {
        // fallback
        const match = digitsOnly.match(/^\d{1,3}/);
        if (match) codeLength = match[0].length;
      }

     // Only validate if there are digits beyond the country code
    if (digitsOnly.length > codeLength) {
      if (!isValidPhoneNumber(data.phone)) {
        newErrors.push('Invalid Phone Number');
      }
      else {
      // Only country code — treat as empty
     // data.phone = '';
    }
    }
    } catch {
      if (!isValidPhoneNumber(data.phone)) {
        newErrors.phone = 'Invalid Phone Number';
      }
    }
  }

  if (data.linkedin_url && !/^https?:\/\/(www\.)?linkedin\.com\/.*$/.test(data.linkedin_url)) {
    //alert('Invalid LinkedIn URL');
    newErrors.linkedin_url = 'Invalid LinkedIn URL';
   // return false;
  }

  return newErrors;
};


  const handleSubmit = async (e) => {
  e.preventDefault();

   console.log('Form submitted!');
  //console.log('Phone number input:', formData.phone);

  // Ensure email is trimmed before validation
  const trimmedFormData = {
    ...formData,
    email: formData.email.trim(),
    firstName: formData.firstName.trim(),
    lastName: formData.lastName.trim(),
  };
 // console.log('Phone after trim (should be the same):', trimmedFormData.phone);
  const formErrors = validate(trimmedFormData);
 // console.log('formData after trim:', formData);

  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    return;
  } else {
      const response = await fetch(app_url+'smwwathlete/addathlete', {
      method: 'POST',
      body: JSON.stringify(trimmedFormData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.result === "user_created") {
        
          setErrors({});
          navigate("/view_athlete/"+data.data.drupal_uid, { state: { message: 'Athlete is created' } });
          // Optional: reset form
          setFormData(initialForm);
      }
   
  }
}; 

  return (
    <div id="main">      
        <div class="left"></div>
		
         <div class="center left-center">
          <Helmet><title>Add Athlete</title></Helmet>
          {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
          <form  className="addathlete-form-container" onSubmit={handleSubmit}>
            <h1>Add Athlete</h1>
            <table className='addathlete-form-table'>
              <tbody>
                <tr className="addathlete-form-row addathlete-form-row-firstName">
                  <td><label htmlFor="firstName">First Name <span className="required" title="This field is required.">*</span></label></td>
                  <td><input id="firstName" className="addathlete-form-input" name="firstName" value={formData.firstName} onChange={handleChange} />
                  {errors.firstName &&
                  <span className="error-message" style={{marginTop:"0px"}}>
                  {errors.firstName}
                  </span>
                  }        
                  </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-lastName">
                  <td><label htmlFor="lastName">Last Name <span className="required" title="This field is required.">*</span></label></td>
                  <td><input id="lastName" className="addathlete-form-input" name="lastName" value={formData.lastName} onChange={handleChange} />
                  {errors.lastName &&
                          <span className="error-message" style={{marginTop:"0px"}}>
                            {errors.lastName}
                          </span>
                        }
                  </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-street">
                  <td><label htmlFor="street">Street Address</label></td>
                  <td><input id="street" className="addathlete-form-input" name="street" value={formData.street} onChange={handleChange} /></td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-addressCont">
                  <td><label htmlFor="addressCont">Address (cont)</label></td>
                  <td><input id="addressCont" className="addathlete-form-input" name="addressCont" value={formData.addressCont} onChange={handleChange} />
                
                  </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-city">
                  <td><label htmlFor="city">City</label></td>
                  <td><input id="city" className="addathlete-form-input" name="city" value={formData.city} onChange={handleChange} />
                </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-state">
                  <td><label htmlFor="state">State</label></td>
                  <td>
                     <select id="state" name="state" value={formData.state}  onChange={handleChange} >
            <option value="">Select State</option>
            {Object.keys(statelist).map(state => {
              return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
            })}
            </select>
                  </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-zip">
                  <td><label htmlFor="zip">Zip/Post Code</label></td>
                  <td><input id="zip" className="addathlete-form-input" name="zip" value={formData.zip} onChange={handleChange} /></td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-country">
                  <td><label htmlFor="country">Country</label></td>
                  <td>
                   <Select 
                             
                             id="country" name="country" className='athlete-select-country'
                             searchable={true}
                             required={true}  
                             clearable={true} 
                             clearOnBlur={true} 
                             clearOnSelect={true}
                             backspaceDelete={true} 
                             
                             style={{backgroundColor:'#ffffff', borderRadius: 5}}
                                                
                             options={countriesList} 
                             
                             onChange={(val) => {
                               if(val.length == 0) {
                                 console.log(val);
                               }
                               else{
                                 setSelectedCountry(val);
                               handleChange(
                                 { target: { value: val[0]['value'], name: 'country' } }
                               )
                               
                               }}
                             }
                             onDropdownOpen={handleOpen}
                             values={selectedcountry} 
                             
                             />
                  </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-linkedin">
                  <td><label htmlFor="linkedin_url">LinkedIn URL</label></td>
                  <td>
                    <input id="linkedin_url" className="addathlete-form-input" name="linkedin_url" value={formData.linkedin_url} onChange={handleChange} />
                    {errors.linkedin_url && <div className='error-message' style={{marginTop:"0px"}}>{errors.linkedin_url}</div>}
                  </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-phone">
                  <td><label htmlFor="phone">Phone</label></td>
                  <td> 
                                            <PhoneInput
                                                international
                                                countryCallingCodeEditable={false}
                                                placeholder="Enter phone number"
                                                className="smww-appn athlete_phone_field"
                                                value={formData.phone}
                                                defaultCountry={formData.phoneCountry || 'US'}
                                                onCountryChange={(country) => {
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  phoneCountry: country,
                                                }));
                                              }}
                                            onChange={(value) => {

                                              if (!value) {
                                                console.log('Phone input cleared.');
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  phone: '',
                                                }));
                                                return;
                                              }

                                              const digitsOnly = value.replace(/\D/g, '');

                                              let codeLength = 0;

                                              if (formData.phoneCountry) {
                                                codeLength = getCountryCallingCode(formData.phoneCountry).length;
                                              } else {
                                                const match = digitsOnly.match(/^\d{1,3}/);
                                                if (match) {
                                                  codeLength = match[0].length;
                                                }
                                              }

                                              if (digitsOnly.length <= codeLength) {
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  phone: '',
                                                }));
                                              } else {
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  phone: value,
                                                }));
                                              }
                                            }}
                                            />
 {errors.phone && <div className='error-message' style={{marginTop:"0px"}}>{errors.phone}</div>}
            </td>
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-email">
                  <td><label htmlFor="email">Email <span className="required" title="This field is required.">*</span></label></td>
                  <td><input id="email" className="addathlete-form-input" name="email" value={formData.email} onChange={handleChange} />
                  {errors.email &&
                          <span className="error-message" style={{marginTop:"0px"}}>
                            {errors.email}
                          </span>
                        }
                  </td>    
                </tr>
                <tr className="addathlete-form-row addathlete-form-row-signingDate">
                  <td><label htmlFor="signing_date">Date of Signing</label></td>
                  <td>
                     <DatePicker
                    id="signing_date"
                    selected={formData.signing_date_obj}
                    onChange={(date) => handleDateChange(date, 'signing_date')}
                    placeholderText=""
                    dateFormat="MM/dd/yyyy"
                    className="form-input"
                  />
                  </td>
                </tr>
                <tr className="addathlete-form-row ">
                  <td><label htmlFor="signing_agent">Signing Agent</label></td>
                  <td> <select
                              id="signing_agent"
                              className="addathlete-form-input addathlete-form-row-signingAgent"
                              name="signing_agent"
                              value={formData.signing_agent}
                              onChange={handleChange}
                            >
                              <option value="">-- Select Signing Agent --</option>
                             {agentlist.length > 0 && (
                              <>              
                              {agentlist.map((item, index) => {
                                return <><option key={item['agent_id']} value={item['agent_id']}>{item['name']}</option></>
                              })}  
                             </>
                             )}
                            </select></td>
                </tr>
                <tr className="addathlete-form-row ">
                  <td><label htmlFor="current_agent">Current Agent</label></td>
                  <td> <select
                              id="current_agent"
                              className="addathlete-form-input addathlete-form-row-currentAgent"
                              name="current_agent"
                              value={formData.current_agent}
                              onChange={handleChange}
                            >
                        <option value="">-- Select Current Agent --</option>
                        {agentlist.length > 0 && (
                         <>              
                        {agentlist.map((item, index) => {
                           return <><option key={item['agent_id']} value={item['agent_id']}>{item['name']}</option></>
                        })}  
                        </>
                        )}
                      </select>
                  </td>
                </tr>
  <tr className="addathlete-form-row addathlete-form-row-assignmentDate">
    <td><label htmlFor="assignment_date">Date of Assignment</label></td>
    <td> <DatePicker
      id="assignment_date"
       selected={formData.assignment_date_obj}
      onChange={(date) => handleDateChange(date, 'assignment_date')}
      placeholderText=""
      dateFormat="MM/dd/yyyy"
      className="addathlete-form-input"
    /></td>
  </tr>
  <tr className="addathlete-form-row addathlete-form-row-birthdate">
    <td><label htmlFor="birthdate">Date of Birth</label></td>
    <td>  <DatePicker
      id="birthdate"
            selected={formData.birthdate_obj}
      onChange={(date) => handleDateChange(date, 'birthdate')}
      placeholderText=""
      dateFormat="MM/dd/yyyy"
      className="form-input"
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={100}
    /></td>
  </tr>
  <tr className="addathlete-form-row addathlete-form-row-bio">
    <td><label htmlFor="bio">Bio</label></td>
    <td><textarea id="bio" className="addathlete-form-input" name="bio" rows={5} value={formData.bio} onChange={handleChange}></textarea></td>
  </tr>
  <tr className="addathlete-form-row ">
    <td><input className="addathlete-form-row-submit" type="submit" value="Add Athlete" /></td>
    <td></td>
  </tr>
</tbody>
      </table>
    </form>
              )}
</div>

	 <div class="right">

              {domainName === configData.RSMWW_DOMAIN && 
                <SalespersonSidebar/>
              }
              {domainName === configData.RSMWW_AGENCY_DOMAIN && 
                <AgentBackendSidebar/>
              }
            
</div>
  <div className='clear'></div>
  </div> 
  );
};

export default AddAthleteForm;